module.exports = "/img/44.ed0f14.webp";